import React from 'react'
import { useCard } from '@orbital/games-frontend-library'
import { colors } from '../../lib/colors'
import { CardFrontWrapper, CardWrapper } from './Styles'
import CardContent from './CardContent'

import { CARD_PROPS } from './interface'

export const CardFront = ({
  background,
  card,
  deal,
  dealOut,
  animDelay,
  flipCard,
  showResult,
}: CARD_PROPS): JSX.Element => {
  const { handleCardColor } = useCard()
  return (
    <CardWrapper deal={deal} flipCard={false} dealOut={dealOut} delay={200}>
      <CardFrontWrapper
        background={background}
        suitColor={handleCardColor(card, colors.cardRed, colors.cardBlack)}
        deal={deal}
        flipCard={flipCard}
        animDelay={animDelay}
        showResult={showResult}
      >
        <CardContent card={card} />
      </CardFrontWrapper>
    </CardWrapper>
  )
}
